import React from 'react';
import './Dashboard.css';

function Packages() {
    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Packages Management</h1>
                    <p>Manage test packages and bundles</p>
                </div>
            </header>

            {/* <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Packages</h3>
                    </div>
                    <div className="info-content-grid">
                        <p>Packages management interface will be implemented here.</p>
                    </div>
                </section>
            </div> */}
        </div>
    );
}

export default Packages;
